'use client';

import clsx from 'clsx';
import { FC } from 'react';
import Button from '~/components/button';
import Checkbox from '~/components/checkbox';
import Divider from '~/components/divider';
import Input from '~/components/input';
import PhoneInput from '~/components/phone-input';
import Textarea from '~/components/textarea';
import WYSIWYGContent from '~/components/wysiwyg-content';

import useCustomerForm from './hook';
import styles from './styles.module.css';

interface Props {
  description?: TrustedHTML | null;
  buttonTitle: string | null;
  agreementText: TrustedHTML | null;
  className?: string;
  serviceName?: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const CustomerForm: FC<Props> = ({
  description,
  buttonTitle,
  agreementText,
  className,
  serviceName,
  onSuccess,
  onError,
}) => {
  const { values, errors, isSubmitting, handleChange, handlePhoneChange, handleSubmit } = useCustomerForm({
    serviceName,
    onSuccess,
    onError,
  });

  return (
    <form className={clsx(styles.form, className)} onSubmit={handleSubmit}>
      {description && (
        <div className={styles.descriptionContainer}>
          <WYSIWYGContent className={styles.formDescription} html={description} />
          <Divider width={80} />
        </div>
      )}
      <div className={styles.inputContainer}>
        <Input
          disabled={isSubmitting}
          placeholder="Имя"
          name="name"
          onChange={handleChange}
          value={values.name}
          error={errors.name}
        />
        <PhoneInput onChange={handlePhoneChange} value={values.phone} error={errors.phone || null} />
        <Textarea
          disabled={isSubmitting}
          placeholder="Ваше сообщение"
          name="message"
          onChange={handleChange}
          value={values.message}
          maxRows={7}
        />
      </div>
      <div className={styles.submitContainer}>
        {buttonTitle && (
          <Button
            className={styles.submit}
            title={buttonTitle}
            buttonProps={{ type: 'submit', disabled: isSubmitting }}
            loading={isSubmitting}
          />
        )}
        <div className={styles.checkboxContainer}>
          <Checkbox
            disabled={isSubmitting}
            onChange={handleChange}
            checked={values.privacyPolicy}
            name="privacyPolicy"
            error={!values.privacyPolicy ? errors.privacyPolicy : null}
          />
          {agreementText && <WYSIWYGContent className={styles.checkboxText} html={agreementText} />}
        </div>

        {!values.privacyPolicy && errors.privacyPolicy && (
          <div className={styles.checkboxError}>Пожалуйста, подтвердите согласие</div>
        )}
      </div>
    </form>
  );
};

export default CustomerForm;
